import { minHeight, styled } from "@mui/system";
import ModalUnstyled from "@mui/base/ModalUnstyled";

export const inputStyle = {
  border: "1px",
  height: "34px",
  borderRadius: "10px",
  backgroundColor: "#FFFFFF",
  borderColor: "#E5E5E5",
  fontSize: "14px",
  color: "#5C5D69",
};

export const tagStyle = {
  backgroundColor: "#F0F0F0",
  height: "34px",
  borderRadius: 10,
  borderWidth: 0,
  marginLeft: 3,
  marginRight: 3,
  color: "#5C5D68",
};

export const tagIconstyle = {
  color: "#5C5D68",
  fontSize: "1.2em",
  stroke: "#5C5D68",
  strokeWidth: 2,
};

export const sportButton = {
  color: "#161729",
  borderColor: "#161729",
  borderWidth: 2,
  width: "40px",
  height: "30px",
  textOverflow: "initial",
  fontSize: "10px",
  fontWeight: "700",
  boxShadow: "none",
  borderRadius: 2,
  justifyContent: "center",
  ".MuiOutlinedInput-notchedOutline": { border: 0 },
};

export const sportButtonDark = {
  ...sportButton,
  color: "#FFFFFF",
  borderColor: "#FFFFFF",
};

export const StyledModal = styled(ModalUnstyled)`
  position: fixed;
  z-index: 1300;
  right: 0;
  bottom: 0;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const AbsoluteStyledModal = styled(ModalUnstyled)`
  z-index: 1300;
  display: flex;
`;

export const managementModalStyle = {
  bgcolor: "background.paper",
  p: 2,
  px: 4,
  pb: 3,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "white",
  borderRadius: "10px",
  width: "30%",
  minHeight: "30%",
  boxShadow: "0px 0px 20px 2px rgba(0,0,0,0.2)",
  overflow: "auto",
  height: "100vh",
};

export const managementInputStyle = {
  border: "0px",
  height: "38px",
  borderRadius: "10px",
  background: "#F0F0F0",
  padding: 7,
  fontSize: "18px",
  fontWeight: "400",
  marginTop: 5,
  marginBottom: 5,
};

export const btnStyle = {
  margin: "0px 0",
  backgroundColor: "#4483C7",
  height: "39px",
  // width: "355px",
  left: "0px",
  top: "25px",
  borderRadius: "10px",
  padding: "10px",
  background: "linear-gradient(87.29deg, #7068AF -42.06%, #EB2A33 120.03%)",
};

export const assignModalStyle = {
  bgcolor: "background.paper",
  p: 1,
  px: 2,
  display: "flex",
  flexDirection: "column",
  alignItems: "left",
  justifyContent: "left",
  backgroundColor: "white",
  borderRadius: "10px",
  width: "200",
  boxShadow: "0px 0px 20px 2px rgba(0,0,0,0.2)",
};
